import React, { Component } from 'react';
import update from 'immutability-helper';

import ContentWrapper from '../../components/ContentWrapper';
import PageTitle from '../../components/PageTitle';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import FloorplanAdd from '../../components/Floorplan/FloorplanAdd';

import { Link, Redirect } from 'react-router-dom';

import 'font-awesome/css/font-awesome.min.css';

// import interact from 'interactjs';

import 'popper.js';


import {
  setTranslateX,
  setTranslateY,
  setZoom,
  loadFloorplans,
  setActiveFloorplan,
  showHidePathPopover,
  setPathPopoverX,
  setPathPopoverY,
  showHidePointPopover,
  addFloorplan
} from '../../reducers/floorplans';

class AddFloorplan extends Component {

  state = {
    floorplanLevel: {value: '', touched: false, error: true, errorText: ''},
    floorplanName: {value: '', touched: false, error: true, errorText: ''},
    form: {error: true},
    uploaded: false,
  }

  changeFloorplanLevel = (event) => {
    this.setState(update(this.state, {floorplanLevel: {value: {$set: event.target.value}, touched: {$set: true}}}), () => {
      if(this.state.floorplanLevel.value.length === 0){
        this.setState(update(this.state, {floorplanLevel: { error: {$set: true}, errorText: {$set: 'Floorplan Level must not be empty'}}}), () => { this.validateFormFields(); });
      } else {

        const floorplanLevelExists = this.props.floorplans.find((floorplan) => {
          return floorplan.floorplan_level === this.state.floorplanLevel.value;
        });

        if(floorplanLevelExists){
          this.setState(update(this.state, {floorplanLevel: { error: {$set: true}, errorText: {$set: 'Floorplan Level already exists'}}}), () => { this.validateFormFields(); });
        } else {
          this.setState(update(this.state, {floorplanLevel: { error: {$set: false}, errorText: {$set: ''}}}), () => { this.validateFormFields(); });
        }
      }
    });
  }

  changeFloorplanName = (event) => {
    this.setState(update(this.state, {floorplanName: {value: {$set: event.target.value}, touched: {$set: true}}}), () => {
      if(this.state.floorplanName.value.length === 0){
        this.setState(update(this.state, {floorplanName: { error: {$set: true}, errorText: {$set: 'Floorplan Name must not be empty'}}}), () => { this.validateFormFields(); });
      } else {
        const floorplanNameExists = this.props.floorplans.find((floorplan) => {
          return floorplan.floorplan_name === this.state.floorplanName.value;
        });
        
        if(floorplanNameExists){
          this.setState(update(this.state, {floorplanName: { error: {$set: true}, errorText: {$set: 'Floorplan Name already exists'}}}), () => { this.validateFormFields(); });
        } else {
          this.setState(update(this.state, {floorplanName: { error: {$set: false}, errorText: {$set: ''}}}), () => { this.validateFormFields(); });
        }
      }
    });
  }

  validateFormFields = () => {
    if(this.state.floorplanName.error || this.state.floorplanLevel.error || this.props.tempAddFloorplan === null){
      this.setState(update(this.state, {form: {error: {$set: true}}}));
    } else {
      this.setState(update(this.state, {form: {error: {$set: false}}}));
    }
  }

  componentWillReceiveProps = () => {
    this.validateFormFields();
  }

  componentDidMount = () => {   
  }

  componentDidUpdate = () => {
  }

  addFloorplan = (event) => {
    event.preventDefault();

    if(!this.state.form.error) { 
      const floorplan = {
        floorplan_name: this.state.floorplanName.value,
        floorplan_level: this.state.floorplanLevel.value,
        is_active: '1'
      };
      
      const data = new FormData()
      data.append('data', JSON.stringify(floorplan));
      data.append('file', this.props.tempAddFloorplan);
      
      this.props.addFloorplan(data, () => {
        this.setState({uploaded: true});
      });
    }

  }

  render() {

    if(this.state.uploaded) {
      return <Redirect to='/floorplans' />
    }

    return (
      <ContentWrapper>
        <div className="inner-content" style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
          <PageTitle>Add Floorplan</PageTitle>

          <div className="container-fluid" style={{marginBottom: '10px'}}>
            <div className="row" role="toolbar">
              <div className="col-md-8">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-inline">
                      <label htmlFor="floorplanLevel" style={{marginRight: '10px'}}>Floorplan Level</label>
                      <input id="floorplanLevel" type="text" className={`form-control ` + (this.props.isAddingFloorplan ? 'disabled' : '') + ` ` + (this.state.floorplanLevel.error && this.state.floorplanLevel.touched ? 'is-invalid' : '')} value={this.state.floorplanLevel.value} onChange={this.changeFloorplanLevel} style={{width: '150px'}} />
                      {this.state.floorplanLevel.error &&
                        <div className="invalid-feedback">
                          {this.state.floorplanLevel.errorText}
                        </div>
                      }
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-inline">
                      <label htmlFor="floorplanName" style={{marginRight: '10px'}}>Floorplan Name</label>
                      <input id="floorplanName" type="text" className={`form-control ` + (this.props.isAddingFloorplan ? 'disabled' : '')  + ` ` + (this.state.floorplanName.error && this.state.floorplanName.touched ? 'is-invalid' : '')} value={this.state.floorplanName.value} onChange={this.changeFloorplanName} style={{width: '150px'}} />
                      {this.state.floorplanName.error &&
                        <div className="invalid-feedback">
                          {this.state.floorplanName.errorText}
                        </div>
                      }
                    </div>
                  </div>
                </div>

              </div>
              <div className="col-md-4 text-right">
                <Link to='/floorplans'><button className="btn btn-light" style={{marginRight: '20px'}}>Cancel</button></Link>
                <button className={`btn btn-primary ` + (this.props.isAddingFloorplan ? 'disabled' : '') + ' ' + (this.state.form.error ? 'disabled' : '')} onClick={this.addFloorplan}>Add Floorplan</button>
              </div>
            </div>
          </div>

          <div className="container-fluid" style={{flexGrow: 1, display: 'flex', flexDirection: 'column'}}>
            <div className="row" style={{height: '100%', display: 'flex', flexGrow: 1, flexDirection: 'column'}}>
              <div className="col-md-12" style={{height: '100%', display: 'flex', flexGrow: 1, flexDirection: 'column'}}>
                <div style={{height: '100%', display: 'flex', flexGrow: 1, flexDirection: 'column', border: 'solid 1px rgba(0,0,0,.1)', padding: '0px'}}>
                  <FloorplanAdd />
                </div>
              </div>
            </div>
          </div>

        </div>
      </ContentWrapper>
    )
  }
}


const mapStateToProps = state => ({
  floorplans: state.floorplans.floorplans,
  activeFloorplanID: state.floorplans.activeFloorplanID,
  translateX: state.floorplans.translateX,
  translateY: state.floorplans.translateY,
  zoom: state.floorplans.zoom,
  showPathPopover: state.floorplans.showPathPopover,
  pathPopoverX: state.floorplans.pathPopoverX,
  pathPopoverY: state.floorplans.pathPopoverY,
  showPointPopover: state.floorplans.showPointPopover,
  pointPopoverX: state.floorplans.pointPopoverX,
  pointPopoverY: state.floorplans.pointPopoverY,
  tempAddFloorplan: state.floorplans.tempAddFloorplan,
  isAddingFloorplan: state.floorplans.isAddingFloorplan
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadFloorplans,
      setActiveFloorplan,
      setTranslateX,
      setTranslateY,
      setZoom,
      showHidePathPopover,
      setPathPopoverX,
      setPathPopoverY,
      showHidePointPopover,
      addFloorplan,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AddFloorplan);


// WEBPACK FOOTER //
// ./src/modules/Floorplans/AddFloorplan.js